import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ScreenContainerOnePotato, ScreenContainerTwoPotato } from './ScreenContainerPotato';
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';

// import Breadcrumbs from '@mui/joy/Breadcrumbs';
// import Link from '@mui/joy/Link';
import Option from '@mui/joy/Option';
import Select from '@mui/joy/Select';

import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';
import Button from '@mui/joy/Button';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Textarea from '@mui/joy/Textarea';



import IconButton from '@mui/joy/IconButton';
import Chip from '@mui/joy/Chip';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';

import { useColorScheme as useJoyColorScheme } from '@mui/joy/styles';
import { useColorScheme as useMaterialColorScheme } from '@mui/material/styles';


import { Success, SimpleMessage } from './FancyToast';
import { Identity } from 'stores/identity_store';
import { getIcon, pluralize } from 'utils/misc';

import { SmallLogo }  from 'components/CombinedLogo';
import DateUI, { Duration } from 'components/Date';
import IdentityAvatar from 'components/IdentityAvatar';
import FancyIcon from 'components/FancyIcon';

import { CardTopStack } from './CardLoggedOut';
import PlansStripe from './PlansStripe';
import useAuth from 'hooks/useAuth';
import { BACKGROUND_GRADIENT_CSS } from '../constants';

// import PotatoForTeams from './PotatoForTeams';
import PotatoFancyHands from './PotatoFancyHands';
import PotatoIntroducingDayOnes from './PotatoIntroducingDayOnes';
import PotatoWhatIsDayOnes from './PotatoWhatIsDayOnes';
import PotatoWhatDoYouGet from './PotatoWhatDoYouGet';
import Next, { sc } from './PotatoNext';


// import imgCountryRoad from 'public/ai-grad/country-road-fullsize.png';


// function ImageContainer({children}: {children: React.ReactNode}) {
//     return (
//         <AspectRatio sx={{ width: 240, borderRadius: 'md' }}>
//             {children}
//         </AspectRatio>
//     );
// }

function ColorSchemeToggle() {
    const { mode, setMode: setMaterialMode } = useMaterialColorScheme();
    const { setMode: setJoyMode } = useJoyColorScheme();

    const [mounted, setMounted] = React.useState(false);


    React.useEffect(() => {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    return (
        <IconButton
            id="toggle-mode"
            size="sm"
            variant="plain"
            color="neutral"
            onClick={() => {
                if (mode === 'light') {
                    setJoyMode('dark');
                    setMaterialMode('dark');
                } else {
                    setJoyMode('light');
                    setMaterialMode('light');
                }
            }}
            sx={{
                backgroundColor: "background.surface",
                borderRadius: '50%',
            }}
        >
            {mode === 'light' ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
        </IconButton>
    );
}

function Tools({ section }: { section: string | undefined | null }) {
    const navigate = useNavigate();
    const { checkingAuth, currentUser } = useAuth();
    const LoadingIcon = getIcon('Replay');
    const HomeIcon = getIcon('Home');
    function setSection(s: string | null) {
        if (s) {
            console.log("setting section to %o", s);
            sc(s);
        }
    }
    //    console.log("rendienrg tools with section : %o", section);
    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
                position: "fixed",
                zIndex: 999,
                right: 4,
                width: "100%",
                px: 2,
                pt: 2
            }}
        >



            <Stack
                sx={{ width: "100%" }}
                spacing={1}
                alignItems="center"
                direction="row">

                <IconButton

                    variant="plain"
                    color="neutral"
                    sx={{
                        backgroundColor: "background.surface",
                        borderRadius: '50%',

                    }}
                    onClick={(_) => sc('first')}>
                    <HomeIcon />
                </IconButton>

                <Select variant="plain"
                    value={section}
                    defaultValue="what-is-fancyhands"
                    onChange={(_, nv) => { setSection(nv) }}>
                    <Option value="first">Home</Option>
                    <Option value="fancy-hands">Fancy Hands</Option>

                    {/*
                    <Option value="what-does-fancy-hands-do">What does Fancy Hands do?</Option>
                    <Option value="who-is-this-for">Who is this for?</Option>
                    */}

                    <Option value="introducing-dayones">Day Ones</Option>
                    <Option value="what-is-day-ones">What Is Day Ones</Option>
                    {/* <Option value="for-teams">For Teams</Option>  */}

                    <Option value="starts-with-collabs">How Does it Work?</Option>
                    {section == 'collab-invites' &&
                        <Option value="collab-invites">Add Collaborators</Option>}
                    {section == 'collab-in-realtime' &&
                        <Option value="collab-in-realtime">Work In Realtime</Option>}

                    <Option value="pricing">Pricing</Option>
                    <Option value="what-do-you-get">What do you get?</Option>
                    <Option value="about-fancyhands">About Us</Option>

                    {section == 'dayones-redo' &&
                        <Option value="dayones-redo">Phew</Option>}

                </Select>

                <Box sx={{ flexGrow: 1 }} />
                <ColorSchemeToggle />
                <Button
                    size="sm"
                    variant="plain"
                    color="neutral"
                    sx={{ backgroundColor: "background.surface" }}
                    onClick={(_) => sc('pricing')}>
                    Plans
                </Button>

                {
                    checkingAuth &&
                    <Typography
                        pr={2}
                        startDecorator={<LoadingIcon />}
                        level="body-sm">
                        Loading
                    </Typography>
                }

                {!checkingAuth && currentUser?.uuid &&
                    <Button
                        size="sm"
                        variant="plain"
                        color="neutral"
                        sx={{ backgroundColor: "background.surface" }}
                        onClick={(_) => navigate('/')}>
                        Dashboard
                    </Button>
                }
                {!checkingAuth && !currentUser?.uuid &&
                    <Button
                        size="sm"
                        variant="plain"
                        color="neutral"
                        sx={{ backgroundColor: "background.surface" }}
                        onClick={(_) => navigate('/login')}>
                        Log&nbsp;In
                    </Button>
                }

            </Stack>



        </Stack>
    );
}





// const Prev = ({nextId} :{nextId: string}) => {
//     const UpIcon = getIcon('ArrowUpward');
//     return (
//         <Chip
//             onClick={() => sc(nextId) }
//             startDecorator={<UpIcon />}>Keep Scrolling</Chip>
//     )
// };


const PlansLoggedOut = () => {
    const [activeCollaboratorCount, setActiveCollaboratorCount] = useState(1);
    const startDate = useMemo(() => { const d = new Date(); d.setMinutes(d.getMinutes() - 5); return d.toString() }, []);
    const [endDate, setEndDate] = useState<string | null>(null);
    const [phoneConnecting, setPhoneConnecting] = useState(false);
    const [phoneInitializing, setPhoneInitializing] = useState(false);
    const [callEnded, setCallEnded] = useState(false);

    const [creatingCollab, setCreatingCollab] = useState(false);
    const [addingCollaborator, setAddingCollaborator] = useState(false);



    const [newNow, setNewNow] = useState(false);

    const PhoneIcon = getIcon('LocalPhone');
    const ReplayIcon = getIcon('Replay');


    const GoalIcon = getIcon("CheckCircleOutlineOutlined");


    const WorldIcon = getIcon('Public');
    const SpeedIcon = getIcon('Speed');
    const AdaptingIcon = getIcon('Insights');
    const FiguringItOutIcon = getIcon('Category');
    const DayOnesIcon = getIcon('WbTwilight');

    // const StarIcon = getIcon('Star');
    // const StorefrontIcon = getIcon('Storefront');
    // const LocalPostOfficeIcon = getIcon('LocalPostOffice');
    // const ProjectIcon = getIcon('ChecklistRtlTwoTone');
    // const WorkEvolveIcon = getIcon('Home');
    // const CheckIcon = getIcon("Check");
    // const ResearchIcon = getIcon('MenuBook');
    // const OfficeIcon = getIcon('Business');
    // const CelebrationIcon = getIcon('Celebration');
    // const StandUpsIcon = getIcon('Groups');
    // const Groups = getIcon('Groups');
    // const SchedulingIcon = getIcon('CalendarMonth');
    // const MoreIcon = getIcon('ReadMore');

    const { initialSection } = useParams();
    const [visibleSection, setVisibleSection] = useState(initialSection);

    useEffect(() => {
        // Remove the feedback form if it's there. just from this page
        document.getElementById("sentry-feedback")?.remove()
        if (initialSection) {
            console.log("setting initial section: %o", initialSection);
            sc(initialSection, 'smooth');
        }
    }, [initialSection]);



    function kickOffPhone() {
        setPhoneInitializing(true);
        setTimeout(() => {
            setPhoneInitializing(false);
            setPhoneConnecting(true);
            setCallEnded(false);
            setTimeout(() => {
                setPhoneConnecting(false);
            }, 2_200);
        }, 750);

    }

    function doAddActiveCollab() {
        setCallEnded(false);
        setAddingCollaborator(true);
        SimpleMessage("Looking for collaborator");
        setTimeout(() => {
            setActiveCollaboratorCount(activeCollaboratorCount + 1);
            setAddingCollaborator(false)
            setTimeout(() => {
                Success("Collaborator added.");
            }, 400);
        }, 400);
    }

    function doCreateCollab(redirect?: boolean | undefined) {
        setCreatingCollab(true);

        setTimeout(() => {
            SimpleMessage("Creating collab.")
            if (redirect) {
                sc("collab-invites");
            }
        }, 200);

        setTimeout(() => {
            Success("Created. Searching for collaborator.")
            setCreatingCollab(false);
            // Success("Great! We're finding someone to work on that.")
        }, 600)

        setTimeout(() => {
            setCreatingCollab(false);
        }, 1_500)

    }

    function onInView(visible: boolean, section: string) {
        if (visible) {
            console.log("setting visible section: %o", section);
            setVisibleSection(section);
            // set the url without moving the page
            if (section == 'first') {
                section = ""
            }
            // use replaceState until i can figure out how to
            // handle the back button with pushState
            window.history.replaceState(null, '', `/welcome/${section}`);
        }
        return visible;
    }

    // function inViewWrapper(section: string, hook?: () => void | undefined) {
    //     return (visible: boolean, section: string) => {
    //     if(visible) {
    //         console.log("setting visible section: %o", section);
    //         setVisibleSection(section);
    //         hook && hook();
    //     }
    //     return visible;
    //     }
    // }


    function collabInvitesInit() {
        setActiveCollaboratorCount(0);
        setTimeout(() => {
            setActiveCollaboratorCount(1);
        }, 1_000);
    }




    function onFirstPage() {
        setTimeout(() => {
            setNewNow(true);
            setTimeout(() => {
                setNewNow(false);
            }, 600);
        }, 50);
    }



    return (
        <>
            <Tools section={visibleSection} />

            <Box
                sx={{
                    width: '100dvw',
                    marginTop: 0,
                    height: "100dvh",
                    overflowY: 'scroll',
                    scrollBehavior: 'smooth',
                    scrollSnapType: 'y mandatory',
                    '& > div': {
                        scrollSnapAlign: 'start',
                    },
                }}
            >

                <ScreenContainerTwoPotato
                    view='first'
                    onInView={onInView}
                    onViewHook={() => onFirstPage()}
                    // onInView={(inview) => onInView(inview, 'first')}
                    window={

                        <Stack
                            sx={{                                //  opacity: 0.3
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundImage: "url(/handmade/flower-closeup.webp);",


                            }}
                        >
                            <Typography
                                level="title-lg"
                                sx={{
                                    backgroundImage: "url(/handmade/flower-closeup.webp);",
                                    // backgroundImage: "url(/ai-grad/country-road-fullsize.jpg);",
                                    backgroundSize: "contain",
                                    backgroundPosition: "center",
                                    // opacity: 0.75,
                                    fontWeight: "bold",
                                    backgroundClip: "text",
                                    textFillColor: "transparent;",
                                    //fontSize: { xs: "12rem", md: "18rem" },
                                    textAlign: "center",
                                    lineHeight: "80%",
                                    transition: "all ease-in-out 0.5s",
                                    fontSize: !newNow ? { xs: "12rem", md: "18rem" } : { xs: "11.9rem", md: '17.8rem' },
                                    filter: !newNow ? "brightness(1.2)  sepia(0.0) opacity(0.6)" : "brightness(1.0) sepia(0.6) opacity(0.7)",

                                }}
                            >New
                            </Typography>
                        </Stack>

                    }
                >
                    <Stack alignItems="center" spacing={3} id="first">
                        <CardTopStack />
                        <Next nextId="what-is-dayones" ks="What is This?" />
                    </Stack>
                </ScreenContainerTwoPotato>




                <PotatoFancyHands
                    onInView={onInView} />

                <PotatoIntroducingDayOnes
                    onInView={onInView} />

                    <PotatoWhatIsDayOnes
                    onInView={onInView} />

                <ScreenContainerTwoPotato
                    view="starts-with-collabs"
                    onInView={onInView}
                    reversed={true}
                    window={
                        <Stack id="starts-with-collabs" spacing={1}
                            direction={{ xs: "row", md: "column" }}
                            alignItems="flex-start"
                        >
                            <Stack sx={{
                                position: "absolute",
                                padding: 1,
                                top: "0px",
                                left: "0px",
                            }} >

                                <SmallLogo />
                            </Stack>
                            <Stack spacing={1}>


                                <FormControl>
                                    <FormLabel><GoalIcon /> Goal</FormLabel>
                                    <FormHelperText>
                                        What are we going to get done?
                                    </FormHelperText>
                                    <Textarea
                                        minRows={3}
                                        // html input attribute
                                        name="description"
                                        value="Call enough stores to get a sense for the current price of bananas in Tulsa..."
                                    />
                                </FormControl>
                                <FormControl>
                                    <Tooltip arrow title="Give it a try!"  >
                                        <Button
                                            disabled={creatingCollab}
                                            onClick={() => doCreateCollab(true)}
                                        >{creatingCollab ? "Creating" : "Create Collab"}</Button>
                                    </Tooltip>
                                </FormControl>
                            </Stack>
                        </Stack>

                    }
                >




                    <Stack spacing={1} pb={2}>
                        <Typography id="create-collab">
                            Collaborate
                        </Typography>
                        <Typography level="title-lg" component="h3">
                            It all starts with Collabs
                        </Typography>

                        <Typography level="body-lg">
                            Collabs are how and where we get things done.
                        </Typography>
                        <Typography level="body-md">
                            Create a <Typography variant="soft">Collab</Typography> and set a goal. It can be an open ended months-long collaboration or a simple phone call.
                        </Typography>

                        <Typography level="body-md">
                            Tell us whatever you can and send it off.
                        </Typography>
                    </Stack>

                    <Next
                        nextId="collab-invites"
                        ks="Let's pretend we're creating a Collab"
                        onClick={doCreateCollab}
                    />


                </ScreenContainerTwoPotato>


                <ScreenContainerTwoPotato
                    view='collab-invites'
                    onInView={onInView}
                    onViewHook={collabInvitesInit}
                    window={
                        <Stack id="collab-invites" spacing={1}>
                            <Stack sx={{
                                position: "absolute",
                                padding: 1,
                                top: "0px",
                                left: "0px",
                            }} >

                                <SmallLogo />
                            </Stack>
                            {activeCollaboratorCount == 0 ?
                                <Chip startDecorator={<FancyIcon name="GroupsOutlined" />}
                                    variant="soft"
                                    color="neutral">Searching for collaborators</Chip>

                                :
                                <Tooltip arrow
                                    placement="top"
                                    title="People clocked in and working on this collab">

                                    <Chip
                                        sx={{ cursor: "default" }}
                                        startDecorator={<FancyIcon name="GroupsOutlined" />}
                                        variant="soft"
                                        color="success">
                                        {pluralize(activeCollaboratorCount, 'Active Collaborator')}
                                    </Chip>
                                </Tooltip>
                            }
                            <Tooltip
                                arrow
                                title="Invite another collaborator ">

                                <Button
                                    disabled={addingCollaborator || activeCollaboratorCount == 0}
                                    variant="outlined"
                                    onClick={() => doAddActiveCollab()} >{addingCollaborator || activeCollaboratorCount == 0 ? "Searching" : "Add Collaborator"}</Button>
                            </Tooltip>
                        </Stack>}

                    reversed={true}>
                    <Typography>
                        Is there room for one more?
                    </Typography>
                    <Typography level="title-lg" component="h3">
                        Add more collaborators
                    </Typography>
                    <Typography level="body-md">
                        Sometimes it's helpful to work with more than one person. Invite additional collaborators. Everyone will be on the same page at the same time.
                    </Typography>

                    <Next
                        nextId="collab-in-realtime"
                        ks="Everything happens in realtime" />

                </ScreenContainerTwoPotato>


                <ScreenContainerTwoPotato
                    reversed={true}
                    view="collab-in-realtime"
                    onInView={onInView}
                    onViewHook={() => { kickOffPhone(); setActiveCollaboratorCount(1) }}
                    window={
                        <Stack alignItems="center">
                            <a id="collab-in-realtime"> </a>
                            <Stack sx={{
                                position: "absolute",
                                padding: 1,
                                top: "0px",
                                left: "0px",
                            }} >

                                <SmallLogo />
                            </Stack>

                            <Stack spacing={1}>
                                <Typography level="title-sm">
                                    Call{' '}

                                    {callEnded ?
                                        <Typography variant="soft" color="warning">Ended</Typography>
                                        :
                                        (phoneInitializing ?
                                            <Typography
                                                variant="outlined"
                                                ml={0.4}
                                                color={"primary"}>Queued</Typography> :
                                            <Typography
                                                variant="soft"
                                                ml={0.4}
                                                color={phoneConnecting ? "primary" : "success"}>{phoneConnecting ? 'Ringing' : 'In Progress'}</Typography>
                                        )

                                    }
                                </Typography>

                                <Typography level="body-sm">
                                    <Stack alignItems="center" spacing={1} direction="row">
                                        <PhoneIcon />
                                        <Stack>
                                            <Typography
                                                endDecorator={
                                                    <Duration start={startDate} end={endDate} />
                                                }>
                                                Duration:
                                            </Typography>
                                            <Typography level="body-xs"
                                                endDecorator={<DateUI dateString={startDate} />}>
                                                Started at
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </Typography>


                                <Stack spacing={0.3}>

                                    <IdentityAvatar
                                        interactive={false}
                                        size="chip"
                                        providedIdentity={{
                                            key: "fake",
                                            role: 'assistant',
                                            presence: '32',
                                            name: "Fancy Hands",
                                            color: "lightblue"
                                        } as Identity}
                                        identityKey={undefined} />
                                    <Typography level="body-sm">
                                        <Tooltip arrow placement="right" title="Copy number to clipboard">
                                            <Chip
                                                startDecorator={<PhoneIcon />}
                                                variant="outlined"
                                                onClick={() => {
                                                    navigator.clipboard.writeText("5555551212")
                                                    Success("Copied phone number to clipboard");
                                                }}
                                                color={"success"}>
                                                {"(555) 555-1212"}
                                            </Chip>
                                        </Tooltip>
                                    </Typography>
                                    <Typography level="body-sm">
                                        <Tooltip arrow placement="right" title="Copy number to clipboard">
                                            <Chip
                                                startDecorator={<PhoneIcon />}
                                                variant="outlined"
                                                onClick={() => {
                                                    navigator.clipboard.writeText("5555551211")
                                                    Success("Copied phone number to clipboard");
                                                }}
                                                color={phoneConnecting ? "primary" : "success"}>
                                                {"(555) 555-1211"}
                                            </Chip>
                                        </Tooltip>
                                        {phoneConnecting ?
                                            <Typography level="body-xs" variant="soft">
                                                Ringing
                                            </Typography>
                                            : null}
                                    </Typography>
                                </Stack>

                            </Stack>
                        </Stack>
                    }
                >
                    <Typography>
                        Stay up to date
                    </Typography>
                    <Typography level="title-lg" component="h3">
                        Everything happens in realtime
                    </Typography>
                    <Typography level="body-md">
                        Chat directly with a human who's looking to help, not reading from a script.
                        Watch in realtime as they clock in, make phone calls, and get your work done.
                    </Typography>

                    <Next
                        nextId="pricing"
                        ks="What does it cost?"
                        onClick={() => {
                            setCallEnded(true);
                            setEndDate(new Date().toString());
                        }} />

                </ScreenContainerTwoPotato>


                <ScreenContainerOnePotato
                    view="pricing"
                    onInView={onInView}
                >

                    <Stack sx={{
                        position: "absolute",
                        padding: 1,
                        bottom: 3,
                        left: 3
                    }} >
                        <Tooltip
                            arrow
                            title="The roll over credits, too">
                            <Typography
                                level="body-sm"
                                sx={{ cursor: "pointer" }}
                            >
                                If you have an existing plan, it's still good!
                            </Typography>
                        </Tooltip>
                    </Stack>

                    <a id="pricing"> </a>

                    <Stack sx={{ width: { xs: 'auto', sm: '700px' } }}>
                        <PlansStripe />
                    </Stack>

                    <Stack pt={1}>
                        <Next
                            nextId="what-do-you-get"
                            ks="What do you get?" />
                    </Stack>

                </ScreenContainerOnePotato>


                <PotatoWhatDoYouGet
                                               onInView={onInView} />
                <ScreenContainerTwoPotato
                    view="about-fancyhands"
                    onInView={onInView}
                    reversed={true}
                    window={
                        <img src="/fh-office-app-history.webp"
                            alt="A selection of screenshots from our app throughout time. The images are on top of an image of the office." />

                    }>

                    <Typography id="about-fancyhands">
                        This is not our first rodeo.
                    </Typography>
                    <Typography level="title-lg">
                        We've been at it since 2010
                    </Typography>
                    <Typography level="body-md">
                        We were here yesterday. We'll be here tomorrow. We'll be here when you need us.
                    </Typography>


                    <List>
                        <ListItem>
                            <ListItemDecorator><WorldIcon /></ListItemDecorator>
                            <ListItemContent>The world keeps changing</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><SpeedIcon /></ListItemDecorator>
                            <ListItemContent>Life won't stop accelerating</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><AdaptingIcon color="success" /></ListItemDecorator>
                            <ListItemContent>You keep adapting</ListItemContent>
                        </ListItem>

                        <ListItem>
                            <ListItemDecorator><FiguringItOutIcon color="primary" /></ListItemDecorator>
                            <ListItemContent>We're still here figuring it all out</ListItemContent>
                        </ListItem>
                        <ListItem>
                            <ListItemDecorator><DayOnesIcon color="danger" /></ListItemDecorator>
                            <ListItemContent>We're your Day Ones</ListItemContent>
                        </ListItem>
                    </List>
                    <Next nextId="dayones-redo" ks="Day Ones" />
                </ScreenContainerTwoPotato>





                <ScreenContainerOnePotato
                    view="dayones-redo"
                    onInView={onInView}
                >
                    <Stack

                        sx={{
                            opacity: 0.8,
                            minHeight: "400px",
                            backgroundSize: "cover",
                            backgroundPosition: "center",

                        }}
                    >

                        <Typography

                            level="title-lg"
                            sx={{
                                backgroundImage: BACKGROUND_GRADIENT_CSS,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                fontWeight: "bold",
                                backgroundClip: "text",
                                textFillColor: "transparent;",
                                fontSize: { xs: "6rem", md: "12rem" },
                                textAlign: "center",
                                fontFamily: "'Oranienbaum', serif",

                            }}
                        >Day Ones
                        </Typography>

                        <Tooltip arrow title="Go, Dog. Go!">
                            <Chip
                                endDecorator={<ReplayIcon />}
                                onClick={() => sc("first")}>

                                Go Around Again.
                            </Chip>
                        </Tooltip>
                    </Stack>

                </ScreenContainerOnePotato>



            </Box>
        </>

    );
};
export default PlansLoggedOut;
